const Questionjson = {
    anxiety: [
        {
            Sno: 1,
            question: "Feeling nervous, anxious or on edge",
            score: 0
        },
        {
            Sno: 1,
            question: "Not being able to stop or control worrying",
            score: 0
        },
        {
            Sno: 2,
            question: "Worrying too much about different things",
            score: 0
        },
        {
            Sno: 3,
            question: "Trouble relaxing",
            score: 0
        },
        {
            Sno: 4,
            question: "Being so restless that it is hard to sit still",
            score: 0
        },
        {
            Sno: 5,
            question: "Becoming easily annoyed or irritable",
            score: 0
        },
        {
            Sno: 6,
            question: "Feeling afraid as if something awful might happen",
            score: 0
        }
    ],

    depression: [
        {
            Sno: 1,
            question: "Little interest or pleasure in doing things",
            score: 0
        },
        {
            Sno: 2,
            question: "Feeling down, depressed, or hopeless",
            score: 0
        },
        {
            Sno: 3,
            question: "Trouble falling or staying asleep, or sleeping too much",
            score: 0
        },
        {
            Sno: 4,
            question: "Feeling tired or having little energy",
            score: 0
        },
        {
            Sno: 5,
            question: "Poor appetite or overeating",
            score: 0
        },
        {
            Sno: 6,
            question: "Feeling bad about yourself — or that you are a failure or have let yourself or your family down",
            score: 0
        },
        {
            Sno: 7,
            question: "Trouble concentrating on things, such as reading the newspaper or watching television",
            score: 0
        },
        {
            Sno: 8,
            question: "Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual",
            score: 0
        },
        {
            Sno: 9,
            question: "Thoughts that you would be better off dead or of hurting yourself in some way",
            score: 0
        }
    ]
}

export default Questionjson